export const en_about = {
  main1: "We provide Information in graphics, power in graphics.",
  main2: "Ubiq: a visual-centric social media platform",
  sub: "With Ubiq, you can get information visually and intuitively with graphical content. From economic content to how-to content, cartoons and photo collections, a wide variety of image-based content and creators await you."
}